export default __webpack_public_path__ + "static/media/Back_Chevron_Dark.3cbdac64.svg";